import { render, staticRenderFns } from "./TermsCondition.vue?vue&type=template&id=2cd9cde0&scoped=true&"
import script from "./TermsCondition.vue?vue&type=script&lang=js&"
export * from "./TermsCondition.vue?vue&type=script&lang=js&"
import style0 from "./TermsCondition.vue?vue&type=style&index=0&id=2cd9cde0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd9cde0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VIcon})
